import { useAddGradeInUrl } from '~/scopes/product/composables/useAddGradeInUrl'
import { useGradeFallback } from '~/scopes/product/composables/useGradeFallback'
import { useInvalidGradeFallback } from '~/scopes/product/composables/useInvalidGradeFallback'
import { useProductRematch } from '~/scopes/product/composables/useProductRematch'
import { useRedirectionToQueryParamsURL } from '~/scopes/product/composables/useRedirectionToQueryParamsURL'
import { useFetchPickers } from '~/scopes/product-core/composables/useFetch/useFetchPickers/useFetchPickers'
import { useFetchProduct } from '~/scopes/product-core/composables/useFetch/useFetchProduct/useFetchProduct'

export function useRedirections() {
  // Redirect if the fetched product's slug does not match the one in URL
  const { data: productResponse } = useFetchProduct()
  void useProductRematch(productResponse)

  // We delete the grade in the URL if it's invalid
  useInvalidGradeFallback()

  // If the selected grade is not available, we fallback to the first available one
  const { data: pickersResponse, selectedOffer } = useFetchPickers()
  useGradeFallback(pickersResponse)

  // If the grade in the URL is missing, we add it based on the default selected grade for the product
  useAddGradeInUrl(selectedOffer)

  // If the URL has a hash, we redirect to the query params URL
  useRedirectionToQueryParamsURL()
}
